export default "__VITE_ASSET__DQs$HXnN__"